import React from "react";
import { withStyles } from "@material-ui/styles";
import { sum } from "lodash";
import clsx from "clsx";

import { Doughnut } from "react-chartjs-2";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import { displayData } from "../../utils/data";

import colors from "../../assets/style/colors";

const styles = {
  centeredValue: {
    position: "absolute",
    top: "0",
    left: "0",
    margin: "0 auto",
    width: "100px",
    height: "100px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  value: {
    fontSize: "2em",
    fontWeight: 500,
    color: colors.black87,
  },
  clickableValue: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  percentage: {
    fontSize: "1.142em",
    color: colors.black87,
    lineHeight: "14px",
  },
  title: {
    fontWeight: 500,
    color: colors.black87,
    textAlign: "center",
    fontSize: "1em",
    marginBottom: "5px",
    maxWidth: "100px",
    lineHeight: "18px",
  },
};

const DashboardDoughnut = (props) => {
  const { classes, title, values, centeredValue, percentage, onClick } = props;

  return (
    <Grid item xs>
      <Grid container direction="column" wrap="nowrap">
        {title && (
          <Grid item className={classes.title}>
            {title}
          </Grid>
        )}
        <Grid item style={{ position: "relative", zIndex: 1200 }}>
          <Box className={classes.centeredValue}>
            {props.icon && <img src={props.icon} alt="icon" />}
            <div
              className={clsx(classes.value, {
                [classes.clickableValue]: onClick,
              })}
              onClick={() => (onClick ? onClick() : null)}
            >
              {displayData(centeredValue || sum(values))}
            </div>
            {percentage && (
              <div className={classes.percentage}>{`(${percentage} %)`}</div>
            )}
          </Box>
          <Doughnut
            width={100}
            height={100}
            data={{
              datasets: [
                {
                  data: values,
                  backgroundColor: props.colors,
                },
              ],
            }}
            options={{
              tooltips: false,
              plugins: {
                datalabels: {
                  display: false,
                },
              },
              cutoutPercentage: 75,
              legend: {
                display: false,
              },
              layout: {
                display: false,
              },
              hover: { mode: null },
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(DashboardDoughnut);
